import React from "react";

import { ResponsiveFormSelect } from "../ResponsiveFormSelect";
import { RESET_FREQUENCY_OPTIONS } from "./constants";
import { ResetFrequencySelectProps } from "./types";

const SHEET_TITLE = "Select reset frequency";
const RULES = { required: "Reset Frequency is required!" } as const;

export const ResetFrequencySelect: React.FC<ResetFrequencySelectProps> = ({
  isCompact,
  control,
  disabled = false,
}) => (
  <ResponsiveFormSelect
    isCompact={isCompact}
    testId="reset-frequency-select"
    rules={RULES}
    name="resetFrequency"
    control={control}
    options={RESET_FREQUENCY_OPTIONS}
    sheetTitle={SHEET_TITLE}
    disabled={disabled}
  />
);
